import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, ICellRendererParams } from 'ag-grid-enterprise';
import { Disclosure } from '../../../../common/models/disclosures/disclosure.model';
import { IconButtonComponent } from '../../../../popper/components/icon-button/icon-button.component';

@Component({
    selector: 'app-download-xml-cell',
    templateUrl: './download-xml-cell.component.html',
    styleUrls: ['./download-xml-cell.component.scss'],
    standalone: true,
    imports: [IconButtonComponent]
})
export class DownloadXmlCellComponent implements OnInit, ICellRendererAngularComp {

  private disclosure: Disclosure;
  private gridApi: GridApi;
  public rowIndex: number = -1;

  constructor() { }
  
  ngOnInit(): void { }

  agInit(params: ICellRendererParams<Disclosure, any>): void {
    this.disclosure = params.data;
    this.gridApi = params.api;
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    this.rowIndex = params.node.rowIndex;
    return false;
  }

  viewXML(): void{
    if ((this.gridApi as any).onActionTrigger) {
      (this.gridApi as any).onActionTrigger({ row: this.rowIndex, action: "viewXml", data: this.disclosure });
    } else {
      console.error("OnActionTrigger not defined");
    }
  }
}
